import { useExperience } from "@/store/useExperience";
import { Box, BoxProps, Button, Image, VStack } from "@chakra-ui/react";
import NextImage from "next/image";
import Link from "next/link";
import Credits from "./credits";

export default function Menu({ ...props }: BoxProps) {
  const requestPlay = useExperience((state) => state.requestPlay);

  return (
    <Box
      bg="rgba(0, 0, 0, 0.7)"
      flexDirection="column"
      px={6}
      py={{ base: 16, lg: 20 }}
      pos="fixed"
      left={0}
      top={0}
      transition="0.5s opacity"
      h="full"
      w="full"
      zIndex={2}
      {...props}
    >
      <VStack gap={14}>
        <Image alt="logo" maxW={{ lg: "20rem" }} asChild>
          <NextImage
            src="/img/logo.png"
            alt="Farilanes"
            height={709}
            width={2480}
            sizes="(min-width: 62em) 320px, 80vw"
            priority
          />
        </Image>

        <VStack gap={4} w="full">
          <Button as="a" variant="outline" _hover={{ color: "black" }} asChild>
            <Link
              href="https://open.spotify.com/artist/4ptkwcflZpkuWrOEDhFUry?si=KUZOuAtnQ8mWtYk23oTSvw"
              target="_blank"
            >
              Spotify
            </Link>
          </Button>
          <Button as="a" variant="outline" _hover={{ color: "black" }} asChild>
            <Link href="https://www.youtube.com/@fairlanes" target="_blank">
              YouTube
            </Link>
          </Button>
          <Button as="a" variant="outline" _hover={{ color: "black" }} asChild>
            <Link href="https://instagram.com/fairlanes__" target="_blank">
              Instagram
            </Link>
          </Button>
          <Button as="a" variant="outline" _hover={{ color: "black" }} asChild>
            <Link href="https://www.tiktok.com/@fairlanes_" target="_blank">
              TikTok
            </Link>
          </Button>
          <Button as="a" variant="outline" _hover={{ color: "black" }} asChild>
            <Link href="mailto:funkyfairlanes@gmail.com">Email</Link>
          </Button>
          <Button variant="subtle" onClick={requestPlay}>
            Jugar
          </Button>
        </VStack>
      </VStack>

      <Credits
        pos="absolute"
        right={{ base: 4, lg: 8 }}
        bottom={{ base: 4, lg: 8 }}
        zIndex={3}
      />
    </Box>
  );
}
